import type { ResetPasswordFormData } from "./store/types";

type ValidationErrors = Partial<Record<keyof ResetPasswordFormData, string>>;

export const validateResetPasswordForm = (
  formData: ResetPasswordFormData
): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate password
  if (!formData.password) {
    errors.password = "Password is required";
  } else if (formData.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  // Validate confirm password
  if (!formData.confirmPassword) {
    errors.confirmPassword = "Please confirm your password";
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return errors;
};
